import React from "react";
import style from "./style.module.css"
import Link from "../../../components/Link";
import { useSelector } from "react-redux";
import { get } from "lodash";

const MobileMenu = ({ isMenuListOpen, menuItem = [], setIsMenuListOpen, isActive }) => {
    const { navbarHeight, screenHeight } = useSelector((state) => get(state, 'storage', {}));
    return (
        <div className={`${style.mobileMenuContainer} ${isMenuListOpen ? style.isActiveMenuList : ''}`} style={navbarHeight ? { top: `${navbarHeight}px`, height: `${screenHeight - navbarHeight}px` } : undefined}>
            <div className={`${style.mobileMenuLinks}`}>
                {
                    menuItem.map((ele) => {
                        return (
                            <Link
                                key={get(ele, 'id', '')}
                                to={get(ele, 'path')}
                                onClick={() => setIsMenuListOpen(false)}
                                className={isActive(get(ele, 'id', ''), get(ele, 'path', '')) ? style.isActive : style.nonActive}
                            >
                                {get(ele, 'label', '')}
                            </Link>
                        )
                    })
                }
            </div>
        </div>
    )
}
export default MobileMenu